import React from 'react';
import { Loader, BaasicTable } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const OrderLinesListTemplate = ({
	viewStore,
	viewStore: { loading, listStore, tableData, queryUtility, noDataItem },
	data,
}) => {
	if (loading) return <Loader />;
	return (
		<section className="k-grid__header--sml spc--top--sml">
			<BaasicTable
				{...{
					listStore,
					data,
					tableData,
					queryUtility,
					viewStore,
					noDataItem,
				}}
				actions={viewStore}
			/>
		</section>
	);
};

export default defaultTemplate(OrderLinesListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/OrderLinesListTemplate.jsx